import { Attr, BelongsTo, HasOne, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";
import type { ResourceContactType } from "shared/types/outreach";

import type CoreVersion from "./CoreVersion";
import type Organisation from "./Organisation";

@Model()
class ContactDetail extends ApplicationRecord {
  static jsonapiType = "contact_details";

  @Attr() address: Record<string, string>;

  @BelongsTo() contact: ResourceContactType;

  @Attr() contactId: number;

  @Attr() contactType: string;

  @Attr({ persist: false }) createdAt: string;

  @Attr() defaultEmail: boolean;

  @Attr() email: string;

  @Attr() invalidEmail: boolean;

  @HasOne() latestVersion: CoreVersion;

  @Attr() note: string;

  @BelongsTo() organisation: Organisation;

  @Attr() organisationId: number;

  @Attr() phone: string;

  @Attr({ persist: false }) updatedAt: string;
}

export default ContactDetail;
